//This will be edited by Pierre, through PRs
export const CURRENT_LIVE_BENCHMARK = new Date("2024-11-07"); //YYYY-MM-DD
